import React, { useState } from 'react';
import { cvFr, cvEng } from "../../assets/index";
import { useTheme } from '../theme/ThemeContext';
import { useClick } from './ClickContext';

function DownloadButton() {
  const [language, setLanguage] = useState("");
  const [showDownloadButton, setShowDownloadButton] = useState(false);
  const {click, setClick} = useClick();
  const {darkTheme} = useTheme();

  const languageChoice = (selectedLanguage) => {
    setLanguage(selectedLanguage);
    setShowDownloadButton(true);
  };

  return (
    <div>
      {!showDownloadButton ?
      (<div>
        {!click && <button onClick={() => setClick(true)}> Download my cv</button>}
       {click && (
        <div className="flex gap-10">
          
          <label  className={darkTheme?"bannerLabel":"bannerLabel2"} htmlFor="french">
            French
            <input
              className="bannerRadio w-40 h-40 md:w-6 md:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10"
              type='radio'
              id='french'
              value="french"
              name='language'
              checked={language === "french"}
              onChange={() => languageChoice("french")}
            />
          </label>
          <label className={darkTheme?"bannerLabel":"bannerLabel2"}  htmlFor="english">
            English
            <input
              className="bannerRadio w-4 h-4 md:w-6 md:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10"
              type='radio'
              id='english'
              value="english"
              name='language'
              checked={language === "english"}
              onChange={() => languageChoice("english")}
            />
          </label>
        </div>
      )}
      </div>) : (
        <>
          {language === "french" ? (
            <a href={cvFr} download="rootchyCvFr.pdf">
              <button>Download French CV</button>
            </a>
          ) : (
            <a href={cvEng} download="rootchyCvEng.pdf">
              <button>Download English CV</button>
            </a>
          )}
        </>
      )}
    </div>
  );
}

export default DownloadButton;
